// SKU material list — the screen's strings in the portal's four languages (2026-10-21).
const en = {
  loadFailed: 'Could not load the material list',
  title: 'Material list',
  itemsCount: '{{n}} item(s)',
  nothingYet: 'nothing yet',
  addMaterial: 'Add material',
  unnamedWarn: '{{n}} row(s) still without a name — those are not saved.',
  colKind: 'Kind',
  colMaterial: 'Material',
  colColour: 'Colour',
  colRmReady: 'RM ready date',
  colSupplier: 'Supplier',
  colQty: 'Qty',
  colUom: 'UoM',
  colSapCode: 'SAP code',
  colSpec: 'Spec',
  colNote: 'Note',
  rmNeedsSave: 'Save the material list first, then this row can carry a date.',
  sapPh: 'if it exists',
  empty: 'No material entered for this SKU yet.',
};

const ko = {
  loadFailed: '자재 목록을 불러오지 못했습니다',
  title: '자재 목록',
  itemsCount: '{{n}}개 항목',
  nothingYet: '아직 없음',
  addMaterial: '자재 추가',
  unnamedWarn: '이름 없는 줄 {{n}}개 — 이 줄은 저장되지 않습니다.',
  colKind: '구분',
  colMaterial: '자재',
  colColour: '색상',
  colRmReady: '원자재 준비일',
  colSupplier: '공급업체',
  colQty: '수량',
  colUom: '단위',
  colSapCode: 'SAP 코드',
  colSpec: '사양',
  colNote: '메모',
  rmNeedsSave: '먼저 자재 목록을 저장해야 이 줄에 날짜를 넣을 수 있습니다.',
  sapPh: '있는 경우',
  empty: '이 SKU에 입력된 자재가 아직 없습니다.',
};

const vi = {
  loadFailed: 'Không tải được danh sách nguyên liệu',
  title: 'Danh sách nguyên liệu',
  itemsCount: '{{n}} mục',
  nothingYet: 'chưa có gì',
  addMaterial: 'Thêm nguyên liệu',
  unnamedWarn: '{{n}} dòng chưa có tên — các dòng này sẽ không được lưu.',
  colKind: 'Loại',
  colMaterial: 'Nguyên liệu',
  colColour: 'Màu',
  colRmReady: 'Ngày RM sẵn sàng',
  colSupplier: 'Nhà cung cấp',
  colQty: 'SL',
  colUom: 'ĐVT',
  colSapCode: 'Mã SAP',
  colSpec: 'Thông số',
  colNote: 'Ghi chú',
  rmNeedsSave: 'Hãy lưu danh sách nguyên liệu trước, sau đó dòng này mới nhập được ngày.',
  sapPh: 'nếu có',
  empty: 'Chưa có nguyên liệu nào cho SKU này.',
};

const zh = {
  loadFailed: '无法加载物料列表',
  title: '物料列表',
  itemsCount: '{{n}} 项',
  nothingYet: '暂无',
  addMaterial: '添加物料',
  unnamedWarn: '{{n}} 行还没有名称 — 这些行不会被保存。',
  colKind: '类型',
  colMaterial: '物料',
  colColour: '颜色',
  colRmReady: 'RM 就绪日期',
  colSupplier: '供应商',
  colQty: '数量',
  colUom: '单位',
  colSapCode: 'SAP 代码',
  colSpec: '规格',
  colNote: '备注',
  rmNeedsSave: '请先保存物料列表，之后此行才能填写日期。',
  sapPh: '如有',
  empty: '此 SKU 尚未录入物料。',
};

// French and Japanese (task #1173, 2026-11-04) — generated from `en`; a string not yet translated reads English.
const fr = {
  "loadFailed": "Impossible de charger la liste des matières",
  "title": "Liste des matières",
  "itemsCount": "{{n}} article(s)",
  "nothingYet": "rien pour le moment",
  "addMaterial": "Ajouter une matière",
  "unnamedWarn": "{{n}} ligne(s) sans nom — elles ne sont pas enregistrées.",
  "colKind": "Type",
  "colMaterial": "Matière",
  "colColour": "Couleur",
  "colRmReady": "Date de disponibilité RM",
  "colSupplier": "Fournisseur",
  "colQty": "Qté",
  "colUom": "UoM",
  "colSapCode": "Code SAP",
  "colSpec": "Spécification",
  "colNote": "Remarque",
  "rmNeedsSave": "Enregistrez d’abord la liste des matières ; cette ligne pourra ensuite porter une date.",
  "sapPh": "s’il existe",
  "empty": "Aucune matière saisie pour ce SKU pour le moment."
};
const ja = {
  "loadFailed": "資材リストを読み込めませんでした",
  "title": "資材リスト",
  "itemsCount": "{{n}}件",
  "nothingYet": "まだありません",
  "addMaterial": "資材を追加",
  "unnamedWarn": "名前のない行が{{n}}行あります。これらは保存されません。",
  "colKind": "種別",
  "colMaterial": "資材",
  "colColour": "色",
  "colRmReady": "RM準備完了日",
  "colSupplier": "仕入先",
  "colQty": "数量",
  "colUom": "UoM",
  "colSapCode": "SAPコード",
  "colSpec": "仕様",
  "colNote": "メモ",
  "rmNeedsSave": "先に資材リストを保存してください。その後、この行に日付を入力できます。",
  "sapPh": "ある場合のみ",
  "empty": "このSKUの資材はまだ入力されていません。"
};

const dictionary = { ns: 'xMat', en, ko, vi, zh, fr, ja };

export default dictionary;
